// jshint esversion:6
import axios from 'axios'
const baseUrl = `${process.env.VUE_APP_ROOT_API}/api`

export default axios.create({
  baseURL: baseUrl
})
